import { cosignatureRequestsTyped, CosignNoteMetaBody } from "@/api/(requests)/cosignatureTyped";

export async function getCosignatureMeta(noteId: string): Promise<CosignNoteMetaBody> {
  return cosignatureRequestsTyped.get_cosign_meta({ urlParams: { noteId } });
}
